import createDocumentData from "../../utils/createDocumentData";

import { Contractor } from "./types/Contractor";

export default function createContractor(firebase, data) {
	const contractor = Contractor.parse(createDocumentData(firebase, "contractors", data));

	return contractor.ref.set(contractor);
}
